import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const PrivateRoute = ({ children, allowedRoles }) => {
  const { user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        fontSize: '24px',
        color: '#00BAF2'
      }}>
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ message: 'Login or signup first to access this page.', from: location }} replace />;
  }

  if (allowedRoles && user.businessInfo && !allowedRoles.includes(user.businessInfo.role)) {
    // Redirect to a dashboard based on their existing role or a general unauthorized page
    if (user.businessInfo.role === 'seller') {
      return <Navigate to="/seller/primary" replace />;
    } else if (user.businessInfo.role === 'buyer') {
      return <Navigate to="/buyer" replace />;
    } else {
      return <Navigate to="/login" state={{ message: 'You do not have permission to access this page.', from: location }} replace />;
    }
  }

  return children;
};

export default PrivateRoute;

